/**
 * The provider-directory filter-form control keys that direct-apply chips target
 * via their `formKey`. Using this enum instead of inline string literals keeps
 * the keys in one place and gives call sites a named reference.
 *
 * Values are the camelCase form-control keys (`keyof IFilterFormValues`), NOT the
 * snake_case URL/API contract in `UrlQueryParams`/`FilterKeys` — those diverge
 * (e.g. `treatment_preferences` vs `treatmentPreferences`) and are a different
 * boundary. Because `IFindMyFitChip.formKey` is typed `keyof IFilterFormValues`,
 * assigning a member whose value is not a real form key fails to compile at the
 * chip definition.
 */
export enum FilterFormKey {
  SPECIALTIES = 'specialties',
  GENDERS = 'genders',
  AGES = 'ages',
  TREATMENT_PREFERENCES = 'treatmentPreferences'
}
